// https://api.github.com/customPages/michaelbenin
// import { canUseDOM } from 'exenv';

export function customPageLoading(customPage = {}, store = {}) {
  return {
    type: 'CUSTOM_PAGE_LOADING',
    customPage,
    store
  };
}

export function customPageLoaded(customPage, store = {}) {
  return {
    type: 'CUSTOM_PAGE_LOADED',
    customPage,
    store
  };
}

export function customPageError(error, store = {}) {
  return {
    type: 'CUSTOM_PAGE_ERROR',
    customPage: {
      isLoading: false,
      error: true,
      errorMessage: error ? error.message : 'no message'
    },
    store
  };
}
